import { ToastProvider } from "@metsooutotec/modes-react-components";
import { RouterProvider } from "react-router-dom";
import { I18nProvider } from "i18n/i18n";
import { router } from "./AppRoutes";
import AuthProvider from "auth/auth-provider";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <I18nProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </I18nProvider>
    </AuthProvider>
  );
}

export default App;
